module.exports = "/assets/site/images/poligonleft.png?25d615f9353fad0821ab84e8f2f30a89";